import styled from 'styled-components'

import Layout from '../layout'
import { Color, IColorScore, PLAYERS_COUNT, useGame } from '../hooks/use-game'
import PlayerScore from '../components/player-score'
import Indicators from '../components/indicators'

export default function Root() {
  const { colorScores, stoneScores, totalScores, setColorScore, setStoneScore } = useGame()

  return (
    <Layout>
      <Container>
        <Indicators />
        {Array.from({ length: PLAYERS_COUNT }).map((_value, index) => (
          <PlayerScore
            colorScores={colorScores[index]}
            index={index}
            setColorScore={(type: keyof IColorScore, color: Color, value: number) =>
              setColorScore(index, type, color, value)
            }
            setStoneScore={(value: number) => setStoneScore(index, value)}
            stoneScore={stoneScores[index]}
            totalScore={totalScores[index]}
          />
        ))}
      </Container>
    </Layout>
  )
}

const Container = styled.div`
  align-items: flex-start;
  background-color: #d8d8d8;
  border-radius: 20px;
  box-shadow: 0px 4px 28px 0px rgba(0, 0, 0, 0.75);
  display: flex;
  flex-direction: row;
  height: calc(100% - 96px);
  justify-content: center;
  width: 824px;

  @media screen and (max-width: 824px) {
    width: 100%;
  }
`
